import { Injectable, Injector } from '@angular/core';

import { HttpRequest, HttpInterceptor, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { from, Observable, of } from 'rxjs';
import { AppMasterDBFacade, PersistentStorageService } from '@monorepo/core-data';
import { map, mergeAll, switchMap, take } from 'rxjs/operators';
// import {AuthProvider} from './auth.provider';
// import {ApplicationContext, VersionManager} from '../modules/core';
// import {APPCONSTANTS} from '../modules/core/providers/app.events';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  #authorizedDomains = ['.ncinga.com', 'strawmine.com', '.zilingofactory.com']; // This will be an array of domains if not a pattern

  constructor(
    private injector: Injector,
    private persistentStorage: PersistentStorageService,
    private appMasterDbFacade: AppMasterDBFacade,
  ) {}
  /*
   * Calls on every http request call from app to services.
   * @fix for Webview native bridge braking scenario on android 10 devices for the first POST request on no network scenario
   * this will return the http error response without sending it through the native layer
   * */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // const auth = this.injector.get(AuthProvider);
    const hasAuthorizedDomain = this.#authorizedDomains.some((v) => {
      return req.url.indexOf(v) >= 0;
    });
    const isValidDomain = req.url && hasAuthorizedDomain;
    const isInValidDomin = !isValidDomain;
    if (req.url && req.url.indexOf('http') == -1 && isInValidDomin) {
      // to avoid app stop loading due to local resources
      return next.handle(req);
    }

    const updateRequest$ = of(req).pipe(
      switchMap((request) =>
        from(this.persistentStorage.get('[LOGIN][AUTHENTICATION_TOKEN]')).pipe(
          map((token) => [request, token] as const),
        ),
      ),
      switchMap((args) =>
        this.appMasterDbFacade.getAppDetails().pipe(
          take(1),
          map((ad) => [...args, ad] as const),
        ),
      ),

      map(([requst, token, appDetails]) => {
        return requst.clone({
          setHeaders: {
            Authorization: 'Bearer ' + token,
            'X-Client-Details': JSON.stringify({
              factoryId: appDetails.factoryId,
              deviceId: appDetails.deviceId,
              appVersion: appDetails.appVersion,
            }),
          },
        });
      }),
      map((v) => next.handle(v)),
      mergeAll(),
    );

    return updateRequest$;
  }
}
